/**
 * Mobility MVP: Info Sheet Component
 * Bottom sheet that displays question-specific explanation text
 * Follows FIGMA #MVP-Sheet-03 pattern
 */

import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';

interface MobilityInfoSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

export function MobilityInfoSheet({ isOpen, onClose, title, content }: MobilityInfoSheetProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="bottom" className="max-h-[80vh]">
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
          <SheetDescription className="text-left mt-4">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm text-muted-foreground whitespace-pre-line">{content}</p>
            </div>
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6">
          <Button onClick={onClose} className="w-full">
            Done
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
